module.exports = __webpack_public_path__ + "static/media/ctv_morningnewschannel_video.28b38605.png";